import React from "react";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Stack, Typography } from "@mui/material";
import { WorkspaceIcon } from "assets/material-custom-icons";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

import { useFilesPickerContext } from "../hooks/files-picker-context";
import { Folder } from "./Folder";

interface IProps {
  workspaceTitle: string;
}

export const WorkspaceFileSelector: React.FC<IProps> = ({ workspaceTitle }) => {
  const { deal, foldersLoading, filesLoading, parentFoldersToRender, setStep, resetState } = useFilesPickerContext();

  const onStepBack = () => {
    setStep("select-deal");
    resetState();
  };

  return (
    <Stack gap="10px">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ borderBottom: "1px solid #DAE0E2" }}
      >
        <Typography>{workspaceTitle}</Typography>
      </Stack>

      {deal && (
        <Stack
          direction="row"
          alignItems="center"
          gap="5px"
          maxWidth="450px"
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          sx={{ paddingLeft: "5px", width: "fit-content" }}
          onClick={onStepBack}
        >
          <KeyboardArrowLeftIcon sx={{ fill: "#0A3142", cursor: "pointer" }} />
          <MaterialTooltip title={deal?.title} placement="top">
            <Typography
              sx={{
                fontSize: "16px",
                color: "#0a3142",
                cursor: "pointer",
                fontWeight: "700",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden"
              }}
            >
              {deal?.title}
            </Typography>
          </MaterialTooltip>
        </Stack>
      )}

      <AsyncContentMui
        isLoading={filesLoading || foldersLoading}
        spinnerProps={{ size: 30 }}
        boxProps={{ sx: { minHeight: "250px" } }}
      >
        <Stack>
          <Stack
            sx={{
              border: "1px solid #DAE0E2",
              padding: "10px",
              height: "250px",
              overflow: "scroll",
              marginBottom: "10px"
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              sx={{ height: "40px", borderBottom: "1px solid #DAE0E2", width: "90%", marginLeft: "40px" }}
            >
              <Stack direction="row" alignItems="center" gap="10px" sx={{ paddingLeft: "10px" }}>
                <WorkspaceIcon sx={{ fill: "#0A3142" }} />
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "#0a3142",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden"
                  }}
                >
                  Workspace
                </Typography>
              </Stack>
            </Stack>

            {parentFoldersToRender.map((folder) => (
              <Folder key={folder.id} folder={folder} subIndex={1} />
            ))}
          </Stack>
        </Stack>
      </AsyncContentMui>
    </Stack>
  );
};
